<div class="container">
  <mat-card class="password-card">
    <mat-card-header>
      <mat-card-title>Change Password</mat-card-title>
      <mat-card-subtitle>Update your account password</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="fill">
          <mat-label>Current Password</mat-label>
          <input
            matInput
            [type]="hideCurrentPassword ? 'password' : 'text'"
            formControlName="currentPassword"
          >
          <button
            type="button"
            mat-icon-button
            matSuffix
            (click)="hideCurrentPassword = !hideCurrentPassword"
          >
            <mat-icon>{{hideCurrentPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="changePasswordForm.get('currentPassword').touched && changePasswordForm.get('currentPassword').errors?.['required']">
            Current password is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>New Password</mat-label>
          <input
            matInput
            [type]="hideNewPassword ? 'password' : 'text'"
            formControlName="newPassword"
          >
          <button
            type="button"
            mat-icon-button
            matSuffix
            (click)="hideNewPassword = !hideNewPassword"
          >
            <mat-icon>{{hideNewPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="changePasswordForm.get('newPassword').touched && changePasswordForm.get('newPassword').errors?.['required']">
            New password is required
          </mat-error>
          <mat-error *ngIf="changePasswordForm.get('newPassword').touched && changePasswordForm.get('newPassword').errors?.['minlength']">
            Password must be at least 6 characters long
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Confirm Password</mat-label>
          <input
            matInput
            [type]="hideConfirmPassword ? 'password' : 'text'"
            formControlName="confirmPassword"
          >
          <button
            type="button"
            mat-icon-button
            matSuffix
            (click)="hideConfirmPassword = !hideConfirmPassword"
          >
            <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="changePasswordForm.get('confirmPassword').touched && changePasswordForm.get('confirmPassword').errors?.['required']">
            Password confirmation is required
          </mat-error>
          <mat-error *ngIf="changePasswordForm.get('confirmPassword').touched && changePasswordForm.errors?.['mismatch']">
            Passwords do not match
          </mat-error>
        </mat-form-field>

        <div class="button-container">
          <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="changePasswordForm.invalid || isLoading"
          >
            <mat-icon *ngIf="isLoading" class="spinner">sync</mat-icon>
            Change Password
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
  <br/>
  <br/>
  <mat-card>
    <mat-card-header>
      <mat-card-subtitle>Controller Screen Pin and Timeout</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <mat-form-field class="example-form-field">
        <mat-label>Screen Pin (4 digits): </mat-label>
        <input #screenPin="ngModel" (keydown)="preventDecimal($event)" (paste)="$event.preventDefault()" matInput type=number min="1000" max="9999" maxlength="4" [ngModel]="configStatus.screenPin">
        <button [disabled]="screenPin.invalid || !screenPin.value" (click)="updateConfig(CradleCommands.SET_LOCK_SCREEN_PIN, screenPin.value)">Update Pin</button>
      </mat-form-field>
      <div class="actions">
        <mat-label>Controller screen timeout: {{configStatus.screenTimeout}} secs</mat-label>
        <mat-slider min="1" max="600" step="1" showTickMarks discrete>
          <input
            matSliderThumb
            [ngModel]="configStatus.screenTimeout"
            (ngModelChange)="updateConfig(CradleCommands.SET_LOCK_SCREEN_TIMEOUT, $event)"
          />
        </mat-slider>
      </div>
    </mat-card-content>
  </mat-card>
</div>
